import React, { useState, useRef, useEffect } from "react";
import dayjs from "dayjs";
import Calendar1 from "../../src/assets/Calender.svg";
import download from "../assets/download.svg";
import filterred from "../assets/filterred.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import CloseIcon from '@mui/icons-material/Close';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import api from "../api/api";
import { useSelector } from "react-redux";
import { div } from "@tensorflow/tfjs";

const HistoryPage = ({
  historycalendar,
   setIsLoading,
  sethistoryCalendar,
  historycalendermodal,
  setHistoryCalenderModal,
  historycalendarref,
  historyData
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [filteredData, setFilteredData] = useState(historyData || []);
  const totalEntries = filteredData.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const [showModal, setShowModal] = useState(false);
    const [istextModalOpen, setIstextModalOpen] = useState(false);
  const [fullText, setFullText] = useState("");
    const [selectedRows, setSelectedRows] = useState([]);
    const user = useSelector((state) => state.user.userDetails);
  const [chipChecks, setChipChecks] = useState({});
const handleCheckboxChange = (row) => {
  setSelectedRows((prev) => {
    const exists = prev.some((r) => r.reportid === row.reportid);
    if (exists) {
      return prev.filter((r) => r.reportid !== row.reportid);
    } else {
      return [...prev, row]; // push the full item
    }
  });
};
  // Update filteredData when historyData changes
  useEffect(() => {
    setFilteredData(historyData || []);
    setCurrentPage(1); // Reset to first page when data changes
  }, [historyData]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleEntriesChange = (e) => {
    setEntriesPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const startIndex = (currentPage - 1) * entriesPerPage;
  const paginatedData = filteredData.slice(
    startIndex,
    startIndex + entriesPerPage
  );

  // Modal states
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const filterIconRef = useRef(null);
  const modalRef = useRef(null);

  // Filter modal data state (checkboxes)
const uniqueOrderedBy = [
  ...new Set(
    (historyData || []).flatMap((item) => [
      item.orderedby,
      item.details?.job_id,
      item.details?.created_by,
    ].filter(Boolean)) // removes undefined/null/empty values
  )
];

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedNames, setSelectedNames] = useState(
    uniqueOrderedBy.reduce((acc, name) => {
      acc[name] = false;
      return acc;
    }, {})
  );
  const [appliedNames, setAppliedNames] = useState({});

  const openFilterModal = () => {
    if (filterIconRef.current) {
      setFilterModalOpen(true);
    }
  };

  const closeFilterModal = () => {
    setFilterModalOpen(false);
    setSearchTerm("");
  };

  // Close modal on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        filterIconRef.current &&
        !filterIconRef.current.contains(event.target)
      ) {
        closeFilterModal();
      }
    }
    if (filterModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filterModalOpen]);

  // Checkbox toggle
  const toggleCheckbox = (name) => {
    setSelectedNames((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  // Remove individual chip
  const removeChip = (name) => {
    setSelectedNames((prev) => ({
      ...prev,
      [name]: false,
    }));
    setAppliedNames((prev) => ({
      ...prev,
      [name]: false,
    }));
    const selected = Object.entries(appliedNames)
      .filter(([_, checked]) => checked && name !== _)
      .map(([name]) => name);
    
    if (selected.length === 0) {
      setFilteredData(historyData || []);
    } else {
      const filtered = (historyData || []).filter((item) =>
        selected.includes(item.orderedby)
      );
      setFilteredData(filtered);
    }
    setCurrentPage(1);
  };

  // Clear filter selections
  const clearFilters = () => {
    const cleared = Object.keys(selectedNames).reduce((acc, name) => {
      acc[name] = false;
      return acc;
    }, {});
    setSelectedNames(cleared);
    setAppliedNames(cleared);
    setFilteredData(historyData || []);
    setFilterModalOpen(false);
    setCurrentPage(1);
  };

  // Filter list based on search term
const filteredNames = searchTerm
  ? uniqueOrderedBy.filter((name) =>
      String(name).toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];



  useEffect(() => {
    function handleClickOutsideCalendar(event) {
      if (
        historycalendermodal &&
        historycalendarref.current &&
        !historycalendarref.current.contains(event.target)
      ) {
        setHistoryCalenderModal(false);
      }
    }
    if (historycalendermodal) {
      document.addEventListener("mousedown", handleClickOutsideCalendar);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideCalendar);
    };
  }, [historycalendermodal, historycalendarref, setHistoryCalenderModal]);

  const onCalendarSubmit = (selectedDateRange) => {
    sethistoryCalendar(selectedDateRange);
    setHistoryCalenderModal(false);
    setCurrentPage(1);
  };

  // Apply filter function
  const applyFilters = () => {
  setAppliedNames({ ...selectedNames });

  const selected = Object.entries(selectedNames)
    .filter(([_, checked]) => checked)
    .map(([name]) => name.toLowerCase()); // normalize for case-insensitive match

  if (selected.length === 0) {
    setFilteredData(historyData || []);
  } else {
    const filtered = (historyData || []).filter((item) => {
      const orderedBy = item.orderedby?.toLowerCase() || '';
      const jobNum = String(item.details?.job_id || '').toLowerCase();
      const createdBy = item.details?.created_by?.toLowerCase() || '';

      return (
        selected.includes(orderedBy) ||
        selected.includes(jobNum) ||
        selected.includes(createdBy)
      );
    });

    setFilteredData(filtered);
  }

  setCurrentPage(1);
  setFilterModalOpen(false);
};
const toggleChipCheck = (chipName) => {
  setChipChecks((prev) => {
    const newState = { ...prev, [chipName]: !prev[chipName] };

    // If user is admin, select/unselect matching rows
    if (user?.user_roles?.role === "Admin") {
      if (newState[chipName]) {
        // ✅ Select all rows matching this chip
        const matching = filteredData.filter(
          (item) =>
            item.orderedby === chipName ||
            String(item.details?.job_id) === chipName ||
            item.details?.created_by === chipName
        );

        setSelectedRows((prevRows) => {
          const ids = new Set(prevRows.map((r) => r.reportid));
          const updated = [...prevRows];
          matching.forEach((row) => {
            if (!ids.has(row.reportid)) updated.push(row);
          });
          return updated;
        });
      } else {
        // ❌ Unselect rows matching this chip
        setSelectedRows((prevRows) =>
          prevRows.filter(
            (r) =>
              !(
                r.orderedby === chipName ||
                String(r.details?.job_id) === chipName ||
                r.details?.created_by === chipName
              )
          )
        );
      }
    }

    return newState;
  });
};

const handlepdf = async (name) => {
  try {
    setIsLoading(true);

    const response = await api.get(`/v1/reports/download/${name}`, {
      responseType: 'blob', // Important: tells Axios to handle binary data
    });

    const file = new Blob([response], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);

    // Open in new tab
    window.open(fileURL, '_blank');
  } catch (error) {
    console.log(error);
  } finally {
    setIsLoading(false);
  }
};

const mergefiles = async () => {
  try {
    if (selectedRows.length === 0) return;

    // Collect file names from selected rows
    const filenames = selectedRows
      .map((row) => row.details?.file_name)
      .filter(Boolean); // remove null/undefined

    console.log("Merging files:", filenames);

    setIsLoading(true);

    // Build query string with multiple filenames
    const query = filenames.map(f => `filenames=${encodeURIComponent(f)}`).join("&");

    const response = await api.get(`/v1/reports/merge-download?${query}`, {
      responseType: "blob", // expecting PDF
    });

    // ✅ Convert blob into downloadable PDF
    const file = new Blob([response], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);

    // Open in new tab
    window.open(fileURL, "_blank");
  } catch (error) {
    console.error("Error merging files:", error);
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div className="mx-2 relative">
      {/* Calendar Button */}
      <div className="flex justify-end gap-4 mb-4">
         {selectedRows.length > 1 && (
          <div className="flex items-center gap-2">
<button
      onClick={() => mergefiles()}
      className="bg-[#900] text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-[#B22222] transition"
    >
      Merge Reports ({selectedRows.length})
    </button>
<CloseIcon className="cursor-pointer "
onClick={()=>setSelectedRows([])}
/>
          </div>
    

  )}

        <div
          className="flex items-center bg-white gap-2 border border-gray-300 py-1 px-3 rounded cursor-pointer min-w-[140px]"
          onClick={() => setHistoryCalenderModal(true)}
        >
          <img src={Calendar1} alt="calendar" className="w-5 h-5" />
        <span className="text-[#293050] font-Font1 text-sm font-inter mt-1">
{historycalendar[0]
  ? `${dayjs(historycalendar[0].startDate).format("MMM DD, YYYY")} - ${dayjs(historycalendar[0].endDate).format("MMM DD, YYYY")}`
  : "Select dates"}

</span>

        </div>
      </div>
    {historycalendermodal && (
  <div
          ref={historycalendarref}
          className="absolute top-15 right-0 z-10 bg-white p-2 rounded shadow"
        >
    <DateRangePicker
      onChange={(item) => sethistoryCalendar([item.selection])}
      ranges={historycalendar}
      moveRangeOnFirstSelection={false}
      maxDate={new Date()}
    />

    {/* ✅ Action buttons */}
    <div className="flex justify-end gap-2 mt-2">
      <button
        className="px-3 py-1 text-sm border rounded text-gray-600 hover:bg-gray-100"
        onClick={() => {

          sethistoryCalendar([
            {
              startDate: dayjs().subtract(7, "day").toDate(),
                   endDate: dayjs().toDate(),
              key: "selection",
            },
          ]);
            setHistoryCalenderModal(false);
        }}
      >
        Reset
      </button>
      <button
        className="px-3 py-1 text-sm border rounded bg-blue-500 text-white hover:bg-blue-600"
        onClick={() => {
     
          setHistoryCalenderModal(false);    // close modal
        }}
      >
        Apply
      </button>
    </div>
  </div>
)}

      {/* Table */}
      <div
        className="w-full max-w-full overflow-auto"
        style={{
          border: "1px solid #E5E7EB",
          borderRadius: "10.5px",
          backgroundColor: "#FFFFFF",
          display: "inline-block",
        }}
      >
        <table className="table-auto border-collapse w-full text-left">
          <thead>
            <tr
              className="text-sm text-left"
              style={{
                background: "#F9FAFB",
                color: "#8B1818",
                borderBottom: "1px solid #F5F5F5",
              }}
            >
                 {user?.user_roles?.role === 'Admin' && <th className="px-4 py-3 font-semibold"></th>}
              <th className="px-4 py-3 font-inter font-semibold w-[30%]">
                <div className="flex items-center gap-2">
                  Ordered By
                  <img
                    src={filterred}
                    alt="filter"
                    className="w-4 h-4 cursor-pointer"
                    onClick={openFilterModal}
                    ref={filterIconRef}
                  />
                </div>
          <div className="flex flex-wrap items-center gap-2 mt-2">
 {Object.entries(appliedNames)
  .filter(([_, checked]) => checked)
  .slice(0, 3)
  .map(([name]) => (
    <div
      key={name}
      className={`border rounded-full font-inter px-2 py-[0px] text-xs flex items-center gap-1 cursor-pointer ${
        chipChecks[name] ? "bg-[#900] text-white" : "bg-[#8B18181A] text-[#8B1818]"
      }`}
      onClick={() => toggleChipCheck(name)}
    >
      {/* ✅ Show checkmark */}
      <input
        type="checkbox"
        checked={!!chipChecks[name]}
        readOnly
        className="w-3 h-3 accent-[#900] cursor-pointer"
      />
      <div className="text-xs font-inter">{name}</div>

      <div
        className="text-gray-600 cursor-pointer"
        onClick={(e) => {
          e.stopPropagation(); // prevent toggling check
          removeChip(name);
        }}
      >
        <CloseIcon style={{ width: "16px", height: "16px" }} />
      </div>
    </div>
  ))}


  {Object.entries(appliedNames).filter(([_, checked]) => checked).length > 3 && (
    <div className="text-xs text-gray-500 font-inter cursor-pointer"   onClick={() => setShowModal(true)}>...</div>
  )}
</div>

              </th>
              <th className="px-4 font-inter font-semibold py-3 w-[10%]">Job Number</th>
              <th className="px-4 font-inter font-semibold py-3 w-[10%]">Created By</th>
                <th className="px-4 font-inter font-semibold py-3 w-[13%]">Description</th>
              <th className="px-4 font-inter font-semibold py-3 w-[10%]">Date Ordered</th>
              <th className="px-4 font-inter font-semibold py-3 w-[15%]">Period of Report</th>
              <th className="px-4 font-inter font-semibold py-3 w-[5%]">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((item, index) => (
              <tr
                key={index}
                style={{
                  background: "#FFFFFF",
                  borderBottom: "1px solid #F5F5F5",
                }}
                className="text-sm text-[#101828] text-left"
              >
               {user?.user_roles?.role === 'Admin' && (
                  <td className="px-4 py-3">
                   <input
  type="checkbox"
  checked={selectedRows.some((r) => r.reportid === item.reportid)}
  onChange={() => handleCheckboxChange(item)}
/>
                  </td>
                )}
                <td className="px-4 py-3">{item?.orderedby}</td>
                 <td className="px-4 py-3">{item?.details?.job_id}</td>
      <td className="px-4 py-3">
  {item?.details?.created_by
    ? item.details.created_by.charAt(0).toUpperCase() + item.details.created_by.slice(1)
    : '-'}
</td>

           <td className="px-4 py-3">
     {item?.details?.task_description?.length > 70 ? (
  <>
    {item.details.task_description.slice(0, 70)}...
    <button
      onClick={() => {
        setFullText(item.details.task_description || '');
        setIstextModalOpen(true);
      }}
      className="text-blue-600 underline ml-1"
    >
      more
    </button>
  </>
) : (
  item.details.task_description
)}

  
      </td>

             <td className="px-4 py-3">
  {typeof item.ordereddate === 'string'
    ? item.ordereddate.split('-').slice(1).concat(item.ordereddate.split('-')[0]).join('/')
    : ''}
</td>
<td className="px-4 py-3">
  {(typeof item.details.start_date === 'string' && typeof item.details.end_date === 'string')
    ? `${item.details.start_date.split('-').slice(1).concat(item.details.start_date.split('-')[0]).join('/')} - ${item.details.end_date.split('-').slice(1).concat(item.details.end_date.split('-')[0]).join('/')}`
    : ''}
</td>

                <td className="px-4 py-3">
                  <div
                  onClick={()=>handlepdf(item?.details?.file_name)}
                  className="rounded-[8.5px] border border-[#E2E8F0] cursor-pointer bg-white p-2 flex items-center justify-center w-fit">
                    <img src={download} className="h-5 w-5" />
                  </div>
                </td>
              </tr>
            ))}
            {paginatedData.length === 0 && (
              <tr>
                <td
                  colSpan={4}
                  className="text-center py-6 text-gray-500 text-sm"
                >
                  No data found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination & Entry Control */}
      <div className="flex flex-col md:flex-row justify-between items-center mt-4 gap-2">
        <div className="flex items-center gap-2 text-sm font-inter">
          <div>
            Showing {(currentPage - 1) * entriesPerPage + 1} to{" "}
            {Math.min(currentPage * entriesPerPage, totalEntries)} of {totalEntries}{" "}
            entries
          </div>
          <label htmlFor="entriesPerPage" className="ml-4">
            Rows per page:
          </label>
          <select
            id="entriesPerPage"
            value={entriesPerPage}
            onChange={handleEntriesChange}
            className="px-2 py-1 border border-gray-300 rounded-md text-sm"
          >
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
            <option value={25}>25</option>
          </select>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-1 rounded-md ${
              currentPage === 1
                ? "bg-gray-200 cursor-not-allowed"
                : "bg-[#900] text-white"
            }`}
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, index) => index + 1).map(
            (page) => (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={`px-3 py-1 rounded-md ${
                  currentPage === page ? "bg-[#900] text-white" : "bg-gray-200"
                }`}
              >
                {page}
              </button>
            )
          )}
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-3 py-1 rounded-md ${
              currentPage === totalPages
                ? "bg-gray-200 cursor-not-allowed"
                : "bg-[#900] text-white"
            }`}
          >
            Next
          </button>
        </div>
      </div>

      {/* Filter Modal */}
      {filterModalOpen && (
        <div
          ref={modalRef}
          style={{
            position: "absolute",
            top: '13%',
            left: '0px',
            zIndex: 9999,
            width: "320px",
            backgroundColor: "#fff",
            borderRadius: "8.5px",
            border: "1px solid #F5F5F5",
            boxShadow:
              "0px 4px 6px -1px rgba(0, 0, 0, 0.10), 0px 2px 4px -2px rgba(0, 0, 0, 0.10)",
            padding: "12px",
          }}
        >
  <h3 className=" font-medium text-[#0A0A0A] mb-3 text-sm text-left">
  Filter Options: Name, Job Number, Created By.
</h3>



          <div className="relative w-full mb-3">
            <FontAwesomeIcon
              icon={faSearch}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"
            />
            <input
              type="text"
              placeholder="Search names..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-3 py-1 border border-gray-300 rounded-md text-sm outline-none"
            />
          </div>

          <div
            style={{
              maxHeight: "150px",
              overflowY: "auto",
              border: "1px solid #E5E7EB",
              borderRadius: "5px",
              padding: "8px",
            }}
          >
            {filteredNames.length === 0&&searchTerm && (
              <div className="text-sm text-gray-500 text-center">
                Result found.
              </div>
            )}

            {filteredNames.map((name) => (
              <label
                key={name}
                className="flex items-center gap-2 text-sm cursor-pointer mb-2 select-none"
                style={{ color: "#101828" }}
              >
                <input
                  type="checkbox"
                  checked={selectedNames[name]}
                  onChange={() => toggleCheckbox(name)}
                  style={{
                    accentColor: "#900",
                    width: "16px",
                    height: "16px",
                    cursor: "pointer",
                  }}
                />
                {name}
              </label>
            ))}
          </div>

          <div className="flex justify-between mt-4">
            <button
              onClick={clearFilters}
              className="text-[#900] text-sm font-medium px-3 py-1 border border-[#900] rounded hover:bg-[#900] hover:text-white transition"
            >
              Clear
            </button>
            <button
              onClick={applyFilters}
              className="bg-[#900] text-white text-sm font-medium px-3 py-1 rounded hover:bg-[#B22222] transition"
            >
              Apply
            </button>
          </div>
        </div>
      )}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-4 rounded shadow-lg max-w-md w-full">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">Applied Filters</h2>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
 <div className="flex flex-wrap gap-2 max-h-60 overflow-y-auto mb-4">
              {Object.entries(appliedNames)
                .filter(([_, checked]) => checked)
                .map(([name]) => (
                  <div
                    key={name}
                    className="border bg-[#8B18181A] rounded-full text-[#8B1818] font-inter px-2 py-[0px] text-xs flex items-center justify-center gap-1"
                  >
                    <div className="text-xs font-inter text-left">{name}</div>
                    <div
                      className="mr-1 text-lg font-bold mb-[2px] text-gray-600 cursor-pointer"
                      onClick={() => removeChip(name)}
                    >
                      <CloseIcon style={{ width: '16px', height: '16px' }} />
                    </div>
                  </div>
                ))}
            </div>

            <div className="flex justify-end">
              <button
                onClick={() => {
                  clearFilters();
                  setShowModal(false);
                }}
                className="text-[#900] text-sm font-medium px-3 py-1 border border-[#900] rounded hover:bg-[#900] hover:text-white transition"
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      )}
      {istextModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white max-w-lg w-full max-h-[80vh] p-6 rounded shadow-lg overflow-y-auto">
            <h2 className="text-lg font-semibold mb-4">Task Description</h2>
            <p className="text-gray-700 text-start whitespace-pre-wrap">{fullText}</p>
            <div className="mt-6 text-right">
              <button
                onClick={()=>{
                  setFullText('')
                  setIstextModalOpen(false)
                }}
                className="px-4 py-2 bg-[#900] text-white rounded "
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HistoryPage;